@if (invalid) {
  <p class="is-error is-overline is-bold">
    {{ errorLabel }}
  </p>
}
